import { styled, css } from 'styled-components';
import { Icon } from '../Icon';
import { getFontWeight } from '../../abstracts';
import { dontForwardProps } from '../../util';
import { StateLayer } from '../../core-components';
export const Container = styled.div.withConfig({
  componentId: "aui__sc-1f6t30z-0"
})(["position:relative;display:inline-block;width:100%;"]);
export const List = styled.ul.withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-1f6t30z-1"
})(["list-style-type:none;padding:0;margin:0;max-height:", ";overflow-y:", ";"], ({
  maxHeight
}) => maxHeight ?? '', ({
  maxHeight
}) => maxHeight ? 'scroll' : '');
export const ListItem = styled.li.withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-1f6t30z-2"
})(["box-sizing:content-box !important;flex-direction:column;cursor:pointer;color:var(--aui-on-surface);padding:0.5rem 0.75rem;margin:0 1px;position:relative;", " ", " :last-of-type{margin-bottom:1px;border-bottom-right-radius:0.5rem;border-bottom-left-radius:0.5rem;}:active{", "{opacity:var(--aui-state-layer-press);}}"], ({
  $subHeader
}) => !$subHeader && css(["height:2rem;line-height:2rem;"]), ({
  isSelected
}) => isSelected && `${StateLayer} {
      opacity: var(--aui-state-layer-hover);
    }`, StateLayer);
export const NoResultsListItem = styled(ListItem).withConfig({
  componentId: "aui__sc-1f6t30z-3"
})(["height:2rem;cursor:inherit;:hover{background:inherit;}"]);
export const CompatIcon = styled(Icon.Compat).withConfig({
  componentId: "aui__sc-1f6t30z-4"
})(["cursor:pointer;"]);
export const DropdownContainer = styled.div.withConfig({
  componentId: "aui__sc-1f6t30z-5"
})(["position:absolute;overflow:hidden;width:100%;top:3rem;z-index:2;"]);
const stylesByFieldStatus = {
  default: css(["border-color:var(--aui-on-surface);box-shadow:inset 0 0 0 1px var(--aui-on-surface);color:var(--aui-on-surface-soft);&:hover{box-shadow:inset 0 0 0 1px var(--aui-on-surface);color:var(--aui-on-surface);}&:focus-within{box-shadow:inset 0 0 0 2px var(--aui-on-surface);color:var(--aui-on-surface-soft);}"]),
  error: css(["border-color:var(--aui-status-error);box-shadow:inset 0 0 0 1px var(--aui-status-error);color:var(--aui-status-error);&:focus-within{box-shadow:inset 0 0 0 2px var(--aui-status-error);}"]),
  warn: css(["border-color:var(--aui-status-warning);box-shadow:inset 0 0 0 1px var(--aui-status-warning);color:var(--aui-on-surface);&:focus-within{box-shadow:inset 0 0 0 2px var(--aui-status-warning);}"]),
  success: css(["border-color:var(--aui-status-success);box-shadow:inset 0 0 0 1px var(--aui-status-success);color:var(--aui-status-success);&:focus-within{box-shadow:inset 0 0 0 2px var(--aui-status-success);}"])
};
export const DropdownContent = styled.div.withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-1f6t30z-6"
})(["color:var(--aui-on-surface-soft);display:grid;margin:0;margin-top:-4px;border:1px solid var(--aui-on-surface);border-bottom-right-radius:0.5rem;border-bottom-left-radius:0.5rem;background:var(--aui-surface);box-shadow:inset 0 0 0 1px var(--aui-on-surface);&:focus-within{box-shadow:inset 0 0 0 2px var(--aui-on-surface);color:var(--aui-on-surface-soft);}", ";@keyframes transitionDropdown{from{opacity:0;visibility:hidden;}to{opacity:1;visibility:visible;}}animation:transitionDropdown 0.2s ease-in-out;"], ({
  fieldStatus
}) => stylesByFieldStatus[fieldStatus]);
export const Divider = styled.div.withConfig({
  componentId: "aui__sc-1f6t30z-7"
})(["margin:0 8px 0 8px;height:10px;border-bottom:1px solid var(--aui-outline-soft);"]);
export const PredictiveTextSubText = styled.div.withConfig({
  componentId: "aui__sc-1f6t30z-8"
})(["font-size:13px;font-weight:", ";line-height:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;text-align:left;color:var(--aui-on-surface-soft);padding-top:0.4rem;"], getFontWeight('feather'));
export const AnnouncerContainer = styled.div.withConfig({
  componentId: "aui__sc-1f6t30z-9"
})(["position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border-width:0;"]);